import { Player } from '@lottiefiles/react-lottie-player';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Avatar, Badge, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Stomp } from '@stomp/stompjs';
import { format, isToday, isYesterday, parseISO } from 'date-fns';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import SockJS from 'sockjs-client';
import loader from './loader.json';
import { GetRecentMessages } from '../../Utils/apiService';
import useStyles from './styles';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import Picker from '@emoji-mart/react';
interface IChatPayload {
  content?: string;
  senderId?: string;
  chatRoomId?: string;
  timestamp?: string;
  attachmentUrl?: string;
}
interface ChatBoxProps {
  onClose: () => void;
  name?: string;
  avatarImg?: string;
  mentordetails?: any;
}
interface ChatBoxProps {
  onClose: () => void;
  name?: string;
  avatarImg?: string;
  mentordetails?: any;
}
const ChatBox: React.FC<ChatBoxProps> = ({ onClose, name, mentordetails }) => {
  const classes = useStyles();
  const [chatMessages, setChatMessages] = useState<any>([]);
  const [newMessage, setNewMessage] = useState('');
  const {
    state: { user } } = useContext(AuthContext);
  const userData = user as any;
  console.log(userData, "userDatauserDatauserDatasamsamsmamsam");
  const idTokens=localStorage.getItem('user');
  const idToken=JSON.parse(idTokens || '{}');
  const [stompClient, setStompClient] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>();
  const [chatRoomId, setChatRoomId] = useState<string | null>(mentordetails?.chatid);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [chatRoomData, setChatRoomData] = useState<any>([]);
  const messageContainerRef = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState<number>(1); // Pagination state
  const [hasMore, setHasMore] = useState<boolean>(true); // Check if more messages are available
  const [isFetchingMessages, setIsFetchingMessages] = useState(false);
  const getFirstLetters = (str: string) => {
    const words = str.split(' ');
    let firstLetters;
    if (words.length === 1) {
      firstLetters = words.map((word) => word.slice(0, 1));
    } else {
      firstLetters = words.slice(0, 2).map((word) => word.slice(0, 1));
    }
    return firstLetters.join('');
  };
  const formatDate = (timestamp: string) => {
    const messageDate = parseISO(timestamp);

    if (isToday(messageDate)) {
      return 'Today';
    } else if (isYesterday(messageDate)) {
      return 'Yesterday';
    } else {
      return format(messageDate, 'MMMM d, yyyy');
    }
  };
  const groupMessagesByDate = (messages?: IChatPayload[]) => {
    const grouped: { [key: string]: IChatPayload[] } = {};

    messages?.forEach((message) => {
      const timestamp = message?.timestamp;
      if (timestamp) {
        const dateLabel = formatDate(timestamp);

        if (!grouped[dateLabel]) {
          grouped[dateLabel] = [];
        }

        grouped[dateLabel].push(message);
      }
    });

    return grouped;
  };
  useEffect(() => {
    let socket: any;
    let client: any;
    let reconnectTimeout: any;

    const connectWebSocket = () => {
      socket = new SockJS(`https://turbosend-dev-bam-api.turboverse.co/chat-websocket`);
      client = Stomp.over(socket);

      client.connect(
        {},
        () => {
          setStompClient(client);
          console.log('WebSocket Connected');
          heartbeat();
        },
        (error: any) => {
          console.log('WebSocket Disconnected, attempting to reconnect...', error);
          reconnectTimeout = setTimeout(() => {
            connectWebSocket();
          }, 5000); // Reconnect after 5 seconds
        }
      );
    };

    const heartbeat = () => {
      client.send('/heartbeat', { Authorization: `Bearer ${idToken?.turbosendToken?.idToken}` }, JSON.stringify({ type: 'ping' }));
    };
    connectWebSocket();
    return () => {
      if (client) {
        client.disconnect(() => console.log('WebSocket Disconnected'));
      }
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
    };
  }, []);
  const subscribeToChatRoom = useCallback(
    (chatRoomId: string) => {
      if (stompClient && stompClient.connected && chatRoomId) {
        const subscription = stompClient.subscribe(`/topic/chatRoom/${chatRoomId}`, (message: any) => {
          const receivedMessage = JSON.parse(message.body);
          setChatMessages((prevMessages: any) => [...prevMessages, receivedMessage]);
        });

        return () => {
          console.log('Unsubscribing from chat room:', chatRoomId);
          subscription.unsubscribe();
        };
      } else {
        console.log('Stomp client not connected or chatRoomId missing:', {
          connected: stompClient?.connected,
          chatRoomId,
        });
      }
      return () => { };
    },
    [stompClient]
  );

  useEffect(() => {
    if (stompClient && chatRoomId) {
      const unsubscribe = subscribeToChatRoom(chatRoomId);
      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } else {
      console.log('Stomp client not ready or no chatRoomId:', { stompClient, chatRoomId });
    }
  }, [stompClient, chatRoomId, subscribeToChatRoom]);
  if (stompClient) {
    stompClient.onStompError = (frame: any) => {
      console.error('STOMP error:', frame);
    };

    stompClient.onDisconnect = (frame: any) => {
      console.log('WebSocket disconnected:', frame);
    };
  }
  const getRecentMessages = useCallback(async () => {
    setIsFetchingMessages(true);
    try {
      const recentMessages = await GetRecentMessages(chatRoomId, page, 20);

      if (recentMessages?.data?.data.length > 0) {
        setChatMessages((prevMessages: any) => {
          const reversedPreviousMessages = [...prevMessages].reverse();
          return [...reversedPreviousMessages, ...recentMessages?.data?.data].reverse();
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
      if (messageContainerRef.current) {
        messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
      }
    } catch (error) {
      console.error('Error fetching recent messages:', error);
    } finally {
      setIsFetchingMessages(false);
    }
  }, [chatRoomData, page, hasMore, isFetchingMessages]);

  useEffect(() => {
    if (((chatRoomData || []).length > 0 || chatRoomId) && hasMore && !isFetchingMessages) {
      getRecentMessages();
    }
  }, [chatRoomData, chatRoomId, getRecentMessages, hasMore, isFetchingMessages]);

  // Scroll to bottom on new messages
  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  // Send new message
  const handleSendMessage = async () => {
    setShowEmojiPicker(false);
    if (newMessage.trim() === '') {
      return;
    }
    console.log(stompClient, chatRoomId, stompClient.connected, "stompClient && chatRoomId && stompClient.connected");

    if (stompClient && chatRoomId && stompClient.connected) {
      const messagePayload = {
        content: newMessage.trim() !== '' ? newMessage : null,
        senderId: userData.applicantId,
        chatRoomId: chatRoomId,
        attachmentUrl: null,
        timestamp: new Date().toISOString(),
        userName: userData?.applicantName
      };
          console.log(messagePayload, 'messagePayload1111');
      stompClient?.send('/app/sendMessage', { Authorization: `Bearer ${idToken?.turbosendToken?.idToken}` }, JSON.stringify(messagePayload));
      setNewMessage('');
    }
  };

  const handleEmojiSelect = (emoji: { native: string }) => {
    setNewMessage((prev) => prev + emoji.native);
  };

  // Grouped messages
  const groupedMessages = groupMessagesByDate(chatMessages);
  const [expandedMessages, setExpandedMessages] = useState<{ [key: number]: boolean }>({});

  const toggleMessage = (index: number) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const [isZoomed, setIsZoomed] = useState(false);
  const handleZoomToggle = () => {
    setIsZoomed(!isZoomed);
  };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    console.log(groupedMessages, 'groupedMessages');
    

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth={isZoomed ? 'xl' : 'sm'}
      fullWidth
      fullScreen={isMobile}
      className={classes.chatBox}
      hideBackdrop
      sx={{
        '& .MuiDialog-paper': {
          display: 'flex',
          flexDirection: 'column',
          borderRadius: isMobile ? 0 : '12px',
          height: isMobile ? '100vh' : undefined,
          maxHeight: isMobile ? '100vh' : undefined,
          ...(isMobile
            ? {}
            : isZoomed
              ? {
                transform: 'scale(1.1)',
                maxWidth: '700px !important',
                height: '60vh',
                transition: 'all 0.3s ease',
                left: '20% !important',
                top: '13% !important',
              }
              : {
                transform: 'scale(1)',
                maxWidth: '500px !important',
                height: '45vh',
                transition: 'all 0.3s ease',
                left: '30% !important',
                top: '20% !important',
              }),
          '& .MuiDialogActions-root': {
            position: 'absolute',
            bottom: 0,
            width: '100%',
            backgroundColor: 'white',
            borderTop: '1px solid #e0e0e0',
          },
        },
        '& .MuiDialogContent-root': {
          overflowY: 'auto',
          marginBottom: '14%',
          padding: '20px',
          flexGrow: 1, // Important for content to stretch inside full height
        },
      }}
    >
      <DialogTitle sx={{ padding: '0px', borderRadius: { xs: '9px', ultraHD: '12px' } }}>
        <Box className={classes.headerContaine}>
          <Box display="flex" alignItems="center">
            <Badge
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              overlap="circular"
              variant="dot"
              color="success"
              sx={{ '& .MuiBadge-dot': { border: '1px solid #fff' } }}
            >
              {mentordetails?.coverImage ? (
                <Avatar
                  src={mentordetails.coverImage}
                  sx={{ width: 40, height: 40 }}
                  alt={name}
                />
              ) : (
                <Avatar
                  sx={{ bgcolor: 'rgba(255, 255, 255, 1)', color: 'rgba(106, 78, 166, 1)' }}
                >
                  {getFirstLetters(name || '')}
                </Avatar>
              )}
            </Badge>
            <Typography className={classes.supportTeamName}>{name ? name : 'Support Team'}</Typography>
          </Box>
          <Box>
            <IconButton
              color="primary"
              onClick={handleZoomToggle}
              aria-label={isZoomed ? "zoom out" : "zoom in"}
              className={classes.closeButton}
            >
              {isZoomed ? (
                <ZoomInMapIcon sx={{ fontSize: { xs: '18px', ultraHD: '24px' } }} />
              ) : (
                <ZoomOutMapIcon sx={{ fontSize: { xs: '18px', ultraHD: '24px' } }} />
              )}
            </IconButton>
            <IconButton color="primary" onClick={onClose} aria-label="close" className={classes.closeButton}>
              <CloseOutlinedIcon sx={{ fontSize: { xs: '18px', ultraHD: '24px' } }} />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent className={`scrollbar-cus ${classes.chatMessagesContainer}`} ref={messageContainerRef}>
        {loading ? (
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', height: '100%', alignItems: 'center' }}>
            <Player autoplay loop src={loader} speed={2} style={{ height: '150px' }}></Player>
          </Box>
        ) : (
          Object.keys(groupedMessages).map((date, index) => (
            <React.Fragment key={`date-${index}`}>
              <Box className={classes.dateSeparator}>
                <Box className={classes.date}>{date}</Box>
              </Box>
              {groupedMessages[date].map((message: any, messageIndex: any) => {
                const messageTime = format(parseISO(message.timestamp), 'hh:mm a');

                return (
                  <React.Fragment key={messageIndex}>
                    <div
                      style={{ fontSize: 10 }}
                      className={message.senderId === userData.applicantId ? classes.chatMessageUsername : classes.chatMessageAdminname}
                    >
                      {message.senderId === userData.applicantId ? 'You' : message?.userName}, {messageTime}
                    </div>
                    <Paper className={message.senderId === userData.applicantId ? classes.chatMessageUser : classes.chatMessageAdmin}>
                      <Typography
                        className={message.senderId === userData.applicantId ? classes.chatMsg : classes.senderMsg}
                        style={{
                          wordBreak: 'break-word',  // Ensures long words break instead of overflowing
                          whiteSpace: 'pre-wrap',   // Respects spaces and new lines
                          overflowWrap: 'break-word' // Ensures wrapping at container width
                        }}
                      >
                        {message.content
                          ? message.content.length > 20 && !expandedMessages[messageIndex]
                            ? `${message.content.slice(0, 500)}`
                            : message.content
                          : ''}
                      </Typography>

                      {message.content && message.content.length > 500 && (
                        <Typography
                          onClick={() => toggleMessage(messageIndex)}
                          style={{ color: '#6A4EA6', cursor: 'pointer', fontSize: '10px', marginTop: '5px', fontWeight: 500, width: '80%' }}
                        >
                          {expandedMessages[messageIndex] ? 'View Less' : 'View More'}
                        </Typography>
                      )}
                    </Paper>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ))
        )}
      </DialogContent>
      <DialogActions style={{ display: 'contents' }}>
        <Box className={classes.messageInputContainer}>
          <div className={classes.dibtextflex}>
            <TextField
              sx={{
                width: '100%',
                '& .MuiInputBase-input': { color: '#585A64' }, // Placeholder color
              }}
              className={classes.messageInput}
              placeholder="Type here"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              multiline
              rows={1}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
              InputProps={{
                sx: { border: 'none', boxShadow: 'none', borderRadius: '1px' },
                classes: {
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
          </div>
        {showEmojiPicker && (
  <Box
    sx={{
      position: 'absolute',
      bottom: '60px',
      right: '10px',
      zIndex: 9999,
    }}
  >
    <Picker
      dynamicWidth={false}
      perLine={8}
      onEmojiSelect={handleEmojiSelect}
    />
  </Box>
)}

          <IconButton onClick={() => setShowEmojiPicker((prev) => !prev)}>
            <EmojiEmotionsOutlinedIcon />
          </IconButton>
          <IconButton color="primary" onClick={handleSendMessage} aria-label="reply" className={classes.replyButton}>
            <SendOutlinedIcon sx={{ color: '#6A4EA6', fontSize: { xs: '18px', ultraHD: '24px' } }} />
          </IconButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
export default ChatBox;